import React, {useContext} from 'react';
import {Card} from "../../../../../components/card/card.jsx";
import {useFormContext} from "react-hook-form";
import useFieldArrayClean from "../../../../../hooks/use-field-array-clean.js";
import Button from "../../../../../components/button/button.jsx";
import {FaPlus, FaTrash} from "react-icons/fa";
import SentryRow from "../../../../../components/template/sentry-row.jsx";
import FormField from "../../../../../components/react-hook-form/form-field.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import InputFile from "../../../../../components/input/input-file.jsx";
import {BoFormContext} from "../context/bo-form-context.jsx";

const BoFormOtherDocuments = () => {
    const {control, watch, setValue} = useFormContext();
    const { verifySyncUrl, otherDocumentTypes } = useContext(BoFormContext);

    const {fields, append, remove} = useFieldArrayClean({
        control,
        name: "otherDocumentsList"
    });

    const addFile = (index, file) => {
        const attachId = Date.now();
        const newFile = Object.assign(file, {attachId});

        const attachs = watch(`otherDocumentsList.${index}.attachs`) ?? [];

        setValue(`otherDocumentsList.${index}.attachs`, [...attachs, newFile]);
    };

    const removeFile = (index, attachId) => {
        const attachs = watch(`otherDocumentsList.${index}.attachs`) ?? [];
        attachs[index].attachId

        setValue(`otherDocumentsList.${index}.attachs`, attachs.filter((attach) => attach?.attachId !== attachId));
    };

    return (
        <Card>
            <Card.Header>
                <Card.Title>Documentos</Card.Title>
            </Card.Header>

            <Card.Body className={"space-y-4"}>
                {
                    fields.map((item, index) => {
                        const attachs = watch(`otherDocumentsList.${index}.attachs`) ?? [];

                        return (
                            <SentryRow className="p-4 border border-[#e5e7eb] rounded-md relative" key={"other-sentry-doc-" + index}>
                                <Button
                                    className="absolute -top-[10px] -right-[10px] !py-0 !px-0 !w-[25px] !h-[25px] z-10"
                                    target="danger"
                                    onClick={() => remove(index)}
                                >
                                    <FaTrash />
                                </Button>

                                <FormField
                                    name={`otherDocumentsList.${index}.type`}
                                    customRender={field => (
                                        <SelectComponent
                                            instanceId={"place"}
                                            value={field?.value ? {label: field.value, value: field.value} : null}
                                            options={otherDocumentTypes}
                                            label={"Tipo *"}
                                            classNameWrapper={"col-span-4"}
                                            onChange={(selected) => field.onChange(selected?.value)}
                                        />
                                    )}
                                />

                                <FormField
                                    as={InputForm}
                                    name={`otherDocumentsList.${index}.value`}
                                    label={"Número/Nome"}
                                    classNameWrapper={"col-span-2"}
                                />

                                {
                                    attachs.map(a => {
                                        if (a && !a?.file) a.url = `${verifySyncUrl(a.attachId)}/${a.attachId}`;

                                        return (
                                            <InputFile
                                                key={a.attachId}
                                                file={a}
                                                removeFile={() => removeFile(index, a.attachId)}
                                                className={"col-span-2"}
                                            />
                                        )
                                    })
                                }

                                <InputFile
                                    setFile={(file) => addFile(index, file)}
                                    className={"col-span-2"}
                                />

                            </SentryRow>
                        )
                    })
                }

                <Button onClick={() => append({ itemId: fields?.at(-1) ? (fields?.at(-1).itemId + 1) : 1 })}>
                    <FaPlus /> Adicionar documento
                </Button>
            </Card.Body>
        </Card>
    );
};

export default BoFormOtherDocuments;